
import React from 'react';

import {Helmet, useParams} from 'views/module';

import EventDetail from 'views/scenes/schedule/event_details/EventDetail';

const EventDetailPage = () => {
  const params = useParams();

  const {eventRn} = params;

  return (
    <>
      <Helmet>
        <title>Quilt: Event Details</title>
      </Helmet>
      <EventDetail
        eventRn={eventRn}
      />
    </>
  );
};

EventDetailPage.propTypes = {
};

export default EventDetailPage;
